import { RequestHandler } from 'express';

import { saveRecorded } from '~/app/mockingMiddleware';

import { migrateModels } from './ContentModels';

import ContentTypeService from '~/services/ContentTypeService';
import DuplicateContentTypeService from '~/services/DuplicateContentTypeService';
import SimpleMigrationService from '~/services/SimpleMigrationService';
import { mapPayloadToMigrateOperations } from '~/transformations/mapPayloadToMigrateOperations';
import mapAppErrorToObject from '~/transformations/mapAppErrorToObject';
import { MigrateRequest } from '~/services';

export const getContentTypes: RequestHandler = async (req, res, next) => {
  try {
    const service = new ContentTypeService(
      res.locals.payload,
      res.locals.preview
    );

    await service.GetSourceRepo();
    res.locals.service = service;
    next();
  } catch (error: any) {
    res.status(500).send({ error: mapAppErrorToObject(error) });
  }
};

export const returnComponents: RequestHandler = (req, res) => {
  const id: string | undefined = res.locals.id;
  const service = res.locals.service as ContentTypeService;
  const response = service.source.context.components.filter(
    (com) => com.id.toLowerCase() === (id || com.id).toLowerCase()
  );
  res.send(response);

  saveRecorded(req, res, {
    operation: 'returnComponents',
    response,
  });
};

export const returnContentTypes: RequestHandler = (req, res) => {
  const service = res.locals.service as ContentTypeService;
  const { id }: { id?: string } = res.locals;

  const response = service.source.context.contentTypes.filter(
    (ct) => ct.id.toLowerCase() === (id || ct.id).toLowerCase()
  );

  res.send(response);

  saveRecorded(req, res, {
    operation: 'returnContentTypes',
    response,
  });
};

export const duplicate: RequestHandler = async (req, res) => {
  const payload = res.locals.payload as MigrateRequest;
  const service = res.locals.service as ContentTypeService;
  const { id, preview } = res.locals;

  // Also check payload for ids
  const { components, contentTypes } = mapPayloadToMigrateOperations(
    payload,
    'duplicate'
  );
  const migrationService = new DuplicateContentTypeService(payload, preview);

  // Get the full components and content types
  const migrate = {
    components: migrationService.source.context.resolve.components(
      id ? [id] : components,
      service.source.context.components
    ),
    contentTypes: migrationService.source.context.resolve.contentTypes(
      id ? [id] : contentTypes,
      service.source.context.contentTypes
    ),
  };

  const results = await migrationService.Duplicate(migrate);
  const response = { committed: !preview, ...results };

  res.send(response);

  saveRecorded(req, res, {
    operation: 'duplicate',
    response,
  });
};

export const migrateContentTypes: RequestHandler = async (req, res) => {
  try {
    const payload = res.locals.payload as MigrateRequest;
    const { id, preview, entity } = res.locals;

    // Also check payload for ids
    const {
      components = [],
      contentTypes = [],
      models,
    } = mapPayloadToMigrateOperations(payload);

    if (Array.isArray(models)) migrateModels(req, res, () => { });
    else {
      const migrationService = new SimpleMigrationService(payload, preview);

      // Get the ids from the url entity param or payload
      const componentIds =
        entity === 'components' && id ? [id] : components || [];
      const contentTypeIds =
        entity === 'contenttypes' && id ? [id] : contentTypes || [];

      const response = await migrationService.Migrate(
        contentTypeIds,
        componentIds
      );

      res.send(response);

      saveRecorded(req, res, {
        operation: 'migrate',
        response,
      });
    }
  } catch (ex: any) {
    res.status(500).send({ error: mapAppErrorToObject(ex) });
  }
};

export const deleteContentTypes: RequestHandler = async (req, res) => {
  try {
    const payload = res.locals.payload as MigrateRequest;
    const { id, preview } = res.locals;

    // Also check payload for ids
    const { components, contentTypes } = mapPayloadToMigrateOperations(
      payload,
      'delete'
    );
    // Get the ids from the id param or payload data
    const componentIds = id ? [id] : components;
    const contentTypeIds = id ? [id] : contentTypes;
    const deleteService = new SimpleMigrationService(payload, preview);

    const response = await deleteService.Delete(contentTypeIds, componentIds);

    res.send(response);

    saveRecorded(req, res, {
      operation: 'deleteContentTypes',
      response,
    });
  } catch (ex: any) {
    res.status(500).send({ error: mapAppErrorToObject(ex) });
  }
};
